import { render } from "./MyTasks.vue?vue&type=template&id=6fe921fe&scoped=true"
import script from "./MyTasks.vue?vue&type=script&lang=js"
export * from "./MyTasks.vue?vue&type=script&lang=js"

import "./MyTasks.vue?vue&type=style&index=0&id=6fe921fe&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe921fe"]])

export default __exports__